import { render, staticRenderFns } from "./QuoteServiceItemsSection.vue?vue&type=template&id=0860389e&scoped=true&"
import script from "./QuoteServiceItemsSection.vue?vue&type=script&lang=ts&"
export * from "./QuoteServiceItemsSection.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteServiceItemsSection.vue?vue&type=style&index=0&id=0860389e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860389e",
  null
  
)

export default component.exports